import { add, parseDate, subtract } from 'helpers/date_utils';
import { formatDate as _formatDate, ISO_DATE_FORMAT } from 'helpers/formatters/date_time_formats';
import { pluralize } from 'helpers/formatters/string_formats';

export function formatDate(deal, fields, date, includeDate = true) {
  if (!date) {
    return null;
  }

  if (date.static) {
    return date.date ? _formatDate(date.date) : null;
  }

  // TODO: Investigate why fields is sometimes empty when this is called so we can remove the ?
  let description = getRelativeDateLabel(deal, fields, date);
  if (date.modifier) {
    description = `${pluralize(date.modifier, date.units)} ${date.operator} ${description}`;
  }

  if (date.date) {
    description = includeDate ? `${_formatDate(date.date)} (${description})` : `(${description})`;
  }

  return description;
}

export function calculateDate(deal, fields, name, date, _visitedNames = new Set()) {
  if (!date) {
    return null;
  }

  _visitedNames.add(name);

  if (date.static) {
    return date.date;
  }

  const relativeName = getRelativeDateName(deal, fields, date);
  if (_visitedNames.has(relativeName)) {
    return null;
  }

  let adjustedDate = calculateDate(deal, fields, relativeName, deal[relativeName], _visitedNames);
  if (adjustedDate) {
    const operation = !date.operator || date.operator === 'before' ? subtract : add;
    adjustedDate = operation(parseDate(adjustedDate), date.modifier || 0, date.units || 'day');
    adjustedDate = _formatDate(adjustedDate, ISO_DATE_FORMAT);
  }

  return adjustedDate;
}

export function getRelativeDateLabel(deal, fields, date) {
  const name = getRelativeDateName(deal, fields, date);
  if (name) {
    return fields[name]?.label || deal[name]?.label;
  }
}

export function isDateSet(date) {
  return date.static ? date.date != null : date.relativeDateId != null;
}

// As a shortcut to handle both new and persisted deals, a date's relativeDateId may be the actual
// date ID, or it may be the field name of that ID
function getRelativeDateName(deal, fields, date) {
  if (typeof date.relativeDateId === 'string') {
    return date.relativeDateId;
  } else if (date.relativeDateId) {
    for (const name in fields) {
      if (fields[name].isDate && deal[name].id === date.relativeDateId) {
        return name;
      }
    }

    for (const name in deal) {
      if (deal[name] && deal[name].adHoc && deal[name].id === date.relativeDateId) {
        return name;
      }
    }
  }
}
